export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const AUTHENTICATE_APPLICATION = "AUTHENTICATE_APPLICATION";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const REQUIRE_OTP = "REQUIRE_OTP";
export const VERIFY_OTP = "VERIFY_OTP";

export const PASSWORD_EXPIRED = "PASSWORD_EXPIRED";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REQUEST_PASSWORD_RESET = "REQUEST_PASSWORD_RESET";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const VERIFY_RESET_PASSWORD_TOKEN = "VERIFY_RESET_PASSWORD_TOKEN";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_GET_POLICY = "CHANGE_PASSWORD_GET_POLICY";

export const VALIDATE_MIGRATION = "VALIDATE_MIGRATION";
export const MIGRATE_USER = "MIGRATE_USER";

export const VERIFY_ONBOARD_TOKEN = "VERIFY_ONBOARD_TOKEN";
export const ACCOUNT_ALREADY_CREATED = "ACCOUNT_ALREADY_CREATED";
export const CREATE_USER_ACCOUNT = "CREATE_USER_ACCOUNT";
export const LOCK_USER_ACCOUNT = "LOCK_USER_ACCOUNT";
export const UNLOCK_USER_ACCOUNT = "UNLOCK_USER_ACCOUNT";

export const CREATE_POLICY = "CREATE_POLICY";
export const EDIT_POLICY = "EDIT_POLICY";
export const GET_POLICIES = "GET_POLICIES";
export const GET_POLICY_DETAIL = "GET_POLICY_DETAIL";

export const CREATE_APPLICATION = "CREATE_APPLICATION";
export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const GET_APPLICATION = "GET_APPLICATION";
export const GET_APPLICATION_USERS = "GET_APPLICATION_USERS";
export const ADD_NEW_USER_TO_APPLICATION = "ADD_NEW_USER_TO_APPLICATION";
export const GET_APP_SALT = "GET_APP_SALT";
export const EDIT_APPLICATION = "EDIT_APPLICATION";
export const DELETE_USER_APPLICATION = "DELETE_USER_APPLICATION";

export const GET_METADATA = "GET_METADATA";
export const RESET_METADATA = "RESET_METADATA";

export const CREATE_GROUP = "CREATE_GROUP";
export const EDIT_GROUP = "EDIT_GROUP";
export const GET_GROUPS = "GET_GROUPS";
export const GET_GROUP = "GET_GROUP";
export const GET_GROUP_USERS = "GET_GROUP_USERS";
export const ADD_NEW_USER_TO_GROUP = "ADD_NEW_USER_TO_GROUP";

export const RESET_INPUTTED_USERS = "RESET_INPUTTED_USERS";
export const ONBOARD_USERS = "ONBOARD_USERS";
export const GET_USERS = "GET_USERS";
export const GET_USER = "GET_USER";
export const EDIT_USER = "EDIT_USER";
export const GET_USER_DETAILS = "GET_USER_DETAILS";

export const READ_SHEET = "READ_SHEET";
export const VALIDATION_ERROR = "VALIDATION_ERROR";
export const RESET_VALIDATION_ERROR = "RESET_VALIDATION_ERROR";
export const DISMISS_VALIDATION_ERROR = "DISMISS_VALIDATION_ERROR";
export const VALIDATE_USERS = "VALIDATE_USERS";

export const GET_ALL_LOGS = "GET_ALL_LOGS";
export const GET_USERS_LOGS = "GET_USERS_LOGS";
export const GET_APPLICATIONS_LOGS = "GET_APPLICATIONS_LOGS";
export const GET_USER_LOGS_BY_ID = "GET_USER_LOGS_BY_ID";
export const GET_APPLICATION_LOGS_BY_ID = "GET_APPLICATION_LOGS_BY_ID";
export const GET_ADMINS_LOGS = "GET_ADMINS_LOGS";
export const GET_MIGRATION_LOGS = "GET_MIGRATION_LOGS";

export const GET_DASHBOARD_DATASET = "GET_DASHBOARD_DATASET";

export const GET_OTP_ROTATION_DETAIL = "GET_OTP_ROTATION_DETAIL";
export const EDIT_OTP_ROTATION = "EDIT_OTP_ROTATION";

export const requestType = (type) => `${type}_REQUEST`;
export const succeedType = (type) => `${type}_SUCCEED`;
export const failedType = (type) => `${type}_FAILED`;
export const finishedType = (type) => `${type}_FINISHED`;
